import React from "react";
import bharatsatexamlogin from "../../assets/images/png/bharatsatexamlogin.png";
import Image from "../Reusable/Image";
const BharatSatExAuthLayout = ({ children }) => {
  return (
    <div>
      <div className="login container">
        <div className="row h-100">
          {/* LEFT LOGIN IMAGE */}
          <div className="col-md-6 m-auto respocollog">
            {/* <div className=""> */}
            <div className=" text-center  d-none d-md-block">
              <div className="position-absolute"><h2 className="Small-Heading fw-600 bharatsatexamloginbackground position-relative  text-white text-start">
              Step into the future with confidence!</h2>
              </div>
              <Image src={bharatsatexamlogin} className="bharat-exam-cover" />
            </div>
            {/* </div> */}
          </div>
          {/* RIGHT SIDE */}
          <div className="col-md-6 m-auto">
            {/* Auth BOX */}
            <div className="login_img" id="btn1">
              {children}
            </div>
          </div>
        </div>
      </div>
    </div>

  );
};

export default BharatSatExAuthLayout;
